var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoiledEgg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25.961px",
    height: "30px",
    viewBox: "0 0 25.961 30",
    style: {
      enableBackground: "new 0 0 25.961 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boiled-egg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.961,7.782C25.961,3.791,23.588,0,21.443,0c-0.004,0-0.006,0-0.006,0c-0.004,0-0.01,0-0.014,0 c-2.145,0-4.521,3.791-4.521,7.782c0,3.28,1.605,5.251,3.369,5.837c0.041,0.18,0.023,0.395,0.02,0.525l-0.486,14.637 C19.785,29.397,20.271,30,20.887,30h0.551h0.535c0.617,0,1.104-0.594,1.084-1.21L22.57,14.17c-0.004-0.131-0.02-0.366,0.02-0.546 C24.354,13.038,25.961,11.063,25.961,7.782z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.673,16C14.885,15.189,15,14.327,15,13.432C15,8.738,11.866,3,8,3S1,8.738,1,13.432C1,14.327,1.115,15.189,1.327,16 H14.673z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,28c-1.104,0-2,0.896-2,2h16c0-1.104-0.896-2-2-2h-4v-4c3-0.815,5.565-3.686,5.943-7H0.057C0.435,20.314,3,23.185,6,24v4 H2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoiledEgg);
export default __webpack_public_path__ + "static/media/boiled-egg.5c730a6f1f95f618cd8bd563f9ee6d8b.svg";
export { ForwardRef as ReactComponent };